import axios from "@/axios";
import {Module} from "vuex";

const state = () => ({
    autocomplete: []
});

const getters = {
    getAutocomplete(state: any){
        return state.autocomplete;
    }
};
const actions = {
    async fetchAutocomplete({commit}: any, key: any){
        const response = await axios.get('/smartcard/autocomplete/'+key);
        commit('saveAutocomplete', response.data);
    }
};
const mutations = {
    saveAutocomplete(state: any, payload: any){
        state.autocomplete = payload;
    }
};

export const autocomplete: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}